import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import common from './common/index.js'
import faq from './faq/index.js'
import user from './user/index.js'
import record from './record/index.js'
import activation from './activation/index.js'
const debug = process.env.NODE_ENV !== 'production'
Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        common,
        faq,
        user,
        record,
        activation
    },
    state: common.state,
    strict: false,
    plugins: debug ? [
        createLogger({
            collapsed: true, // 自动展开输出的 mutations
            transformer(state) {
                // 输出前对 state 进行转换
                // 比如说只返回一个 sub-tree
                return state.subTree
            }
        })
    ] : []
})